import { client } from "../request";

export interface SaveServiceTaskDefault {
  id?: string;
  name: string;
  value: string | number;
  code?: string;
}

/**
 * SAVE TASK DEFAULT
 */
export async function saveServiceTaskDefault(params: SaveServiceTaskDefault) {
  const data = new FormData();
  if (params.id) {
    data.append("id", params.id);
  }
  data.append("name", params.name);
  data.append("value", params.value as string);
  await client.post("create_service_task_default.php", data);
}

/**
 * 現場のプロパティキーを削除する
 */
export async function deleteServiceTaskDefault(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await client.post("delete_service_task_default.php", data);
}

export interface ServiceTaskDefault {
  id: string;
  name: string;
  value: string;
  code?: string;
}

/**
 * 現場のプロパティキーを取得する
 */
export async function getServiceTaskDefault(
  id: string
): Promise<ServiceTaskDefault | null> {
  return await client.get("get_service_task_default.php", { id });
}

/**
 * 現場のプロパティキーの一覧を取得する
 */
export async function getServiceTaskDefaults(): Promise<ServiceTaskDefault[]> {
  return await client.get("get_all_service_task_defaults.php");
}
